import { LiabilityFormData, LiabilityTypeLabelBuilder } from './types';

export class CreditCommitmentLabelBuilder implements LiabilityTypeLabelBuilder {
  private labels: { [key in keyof LiabilityFormData]: string };

  constructor() {
    this.labels = {
      type: '',
      creditCardBalance: '',
      amount: '',
      commitmentEnds: '',
      isClearedBeforeLoanCompletes: '',
    };
  }

  getLabel(field: keyof LiabilityFormData): string {
    return this.labels[field];
  }

  setType(label: string) {
    this.labels.type = label;
  }

  setAmount(label: string) {
    this.labels.amount = label;
  }

  setCreditCardBalance(label: string) {
    this.labels.creditCardBalance = label;
  }

  setIsClearedBeforeLoanCompletes(label: string) {
    this.labels.isClearedBeforeLoanCompletes = label;
  }

  setCommitmentEnd(label: string) {
    this.labels.commitmentEnds = label;
  }
}
